/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative'
  },
  image: {
    height: 350,
    width: '100%'
  },
  content: {
    position: 'absolute',
    top: 340,
    bottom: 0,
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    borderTopColor: '#F5F5F5',
    borderTopWidth: 1,
    backgroundColor: '#FFFFFF'
  },
  banner: {
    height: 350,
  },
  footer: {
    position: 'absolute',
    width: '100%',
    bottom: 24,
    paddingHorizontal: 24
  }
});
